export default __webpack_public_path__ + "static/icon-1-3-cc295a009c8537e6eb68836dadd4ca9e.png";